import React, { useContext, useEffect, useState } from "react";
import "../dashboard.css";
import Footer from "../../footer/footer";

import { EXHIBITOR_MENU_LIST, deleteUser } from "../../../utility/utility";
import Dashboard from "./Dashboard";
import { Route, Routes, useNavigate, useParams } from "react-router-dom";
import Settings from "./Settings";
import Onsite from "./Onsite";
import Reports from "./Reports";
import ProfileDetails from "./profile/ProfileDetails";
import SideMenuList from "./profile/SideMenuList";
import MuPb from "../../../widgets/MuPb";
import { Alert, Box, useMediaQuery, useTheme } from "@mui/material";
import ExhibitionCatalogue from "./oes/ExhibitionCatalogue";
import MySchedule from "./MySchedule";
import GeneralView from "../../floorplan/view/GeneralView";
import AllMeetings from "./meeting/AllMeetings";
import ChatApp from "../../chatApp/ChatApp";
import MyFavorites from "../favorites/MyFavorites";
import ScheduleMeeting from "./meeting/ScheduleMeeting";
import ProductContainer from "./ProductContainer";
import ProfileViewers from "../favorites/ProfileViewers";
import MyStallViewers from "../favorites/MyStallViewers";
import MyChatList from "../common/MyChatList";
import NotificationsList from "./NotificationsList";
import { UserContext } from "../../context/UserContext";
import OesForms from "./OesForms";
import SupportRequest from "../../../pages/SupportRequest";
import AddTeamMembers from "./AddTeamMembers";
import TeamMembers from "./TeamMembers";
import ExhibitorHeader from "../header/ExhibitorHeader";
import Exhibitors from "./explore/Exhibitors";
import Visitors from "./explore/Visitors";
import VisitorProfileDetail from "../visitor/VisitorProfileDetail";
import Products from "./explore/Products";
import { io } from "socket.io-client";
import Matchmaking from "./explore/Matchmaking";
import { API_ENDPOINT } from "../../../constants/constants";
import ExhibitorProfileView from "./profile/ExhibitorProfileView";
import ProfileDetailCommon from "../common/ProfileDetailCommon";
import MeetingItem from "./meeting/Meeting";
import MeetingReschedule from "./meeting/MeetingReschedule";
import MutualFavorites from "../favorites/MutualFavorites";
import Leads from "./Leads";
const ExhibitorDashboard = () => {
  const navigate = useNavigate();
  const { page } = useParams();

  const loc = document.location.href.replace(/\/+$/, "");
  const keysUrl = loc.split("/");
  const isOes = keysUrl[4] && keysUrl[4].includes("oes-forms");
  const theme = useTheme();
  const isLargeScreen = useMediaQuery(theme.breakpoints.up("sm"));
  const { user, loading, logout } = useContext(UserContext);
  const [socket, setSocket] = useState(null);

  useEffect(() => {
    const newSocket = io(API_ENDPOINT, {
      transports: ["websocket"],
    });

    // Log successful connection
    newSocket.on("connect", () => {
      console.log(`Connected to server with socket ID: ${newSocket.id}`);
    });

    setSocket(newSocket);

    return () => {
      newSocket.close();
    };
  }, [setSocket]);

  useEffect(() => {
    if (socket !== null) {
      console.log(`Socket connected: ${socket}`);
    }
  }, [socket]);

  const onLogout = () => {
    logout();
  };
  if (loading) {
    return <MuPb />;
  }
  if (!user) {
    return <Alert severity="error">No user data found!</Alert>;
  }
  const showMenu = isLargeScreen;

  return (
    <>
      <ExhibitorHeader />

      <Box
        position={"fixed"}
        top={"86px"}
        left={0}
        display={isLargeScreen ? undefined : "none"}
        zIndex={100}
      >
        <SideMenuList
          onLogout={onLogout}
          menuList={EXHIBITOR_MENU_LIST}
          page={page}
        />
      </Box>
      <Box
        component="main"
        display="flex"
        id="main-content-box"
        flexDirection="column"
        width="100%"
        sx={{
          marginTop: "86px",
          height: "calc(100vh - 86px)",
          overflowY: "auto",
        }}
      >
        <Box
          pr={2}
          pl={isLargeScreen ? 2 : 2}
          pt={2}
          pb={4}
          flexGrow={1}
          ml={showMenu ? "240px" : undefined}
        >
          <Routes>
            <Route path="" element={<Dashboard />} />
            <Route path="profile" element={<ProfileDetails />} />
            <Route path="floor-plan" element={<GeneralView />} />
            <Route path="add-team-member" element={<AddTeamMembers />} />
            <Route path="edit-team-member/:id" element={<AddTeamMembers />} />
            <Route path="team-members" element={<TeamMembers />} />
            <Route path="explore/exhibitors-list" element={<Exhibitors />} />
            <Route path="explore/visitors" element={<Visitors />} />
            <Route
              path="explore/trade-delegates"
              element={<Visitors type={"td"} />}
            />
            <Route path="explore/products" element={<Products />} />
            <Route path="explore/matchmaking" element={<Matchmaking />} />
            <Route path="visitor-view/:id" element={<VisitorProfileDetail />} />
            <Route
              path="trade_delegate-view/:id"
              element={<VisitorProfileDetail />}
            />
            <Route
              path="exhibitor-view/:id"
              element={<ExhibitorProfileView />}
            />
            <Route
              path="exhibition-catalogue"
              element={<ExhibitionCatalogue />}
            />
            <Route path="meetings" element={<AllMeetings />} />
            <Route path="leads" element={<Leads />} />
            <Route path="meeting/:id" element={<MeetingItem />} />
            <Route path="reschedule/:id" element={<MeetingReschedule />} />

            <Route path="oes-forms" element={<OesForms />} />
            <Route path="my-schedule" element={<MySchedule />} />
            <Route path="support-request" element={<SupportRequest />} />
            <Route path="favorites" element={<MyFavorites />} />
            <Route path="settings" element={<Settings />} />
            <Route path="onsite" element={<Onsite />} />
            <Route path="reports" element={<Reports />} />
            <Route path="product-view/:id" element={<ProductContainer />} />
            <Route path="profile-viewers" element={<ProfileViewers />} />
            <Route path="stall-viewers" element={<MyStallViewers />} />
            <Route path="chat" element={<ChatApp />} />
            <Route path="profile-view/:id" element={<ProfileDetailCommon />} />
            <Route path="meeting-scheduler" element={<ScheduleMeeting />} />
            <Route path="my-chats" element={<MyChatList />} />
            <Route path="mutual-connections" element={<MutualFavorites />} />
            <Route path="my-notifications" element={<NotificationsList />} />
          </Routes>
        </Box>
        <Footer />
      </Box>
    </>
  );
};

export default ExhibitorDashboard;
